import { render, staticRenderFns } from "./About.vue?vue&type=template&id=977d42a0&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=977d42a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977d42a0",
  null
  
)

export default component.exports